<template>
  <base-button
    class="arrow-button"
    :class="classObject"
    :link="link"
    :text="text"
    :button-color="buttonColor"
    :content-fit="contentFit"
    :outlined="outlined"
    :shadow="shadow"
    :rounded="rounded"
    :disabled="disabled"
    :new-button="newButton"
  >
    <template #arrowImage>
      <icon-arrow :direction="facing" />
    </template>
  </base-button>
</template>

<script setup>

const props = defineProps({
  /**
   * ボタンテキスト
   */
    text: {
    type: String,
    required: true,
  },
  /**
   * 矢印の位置
   * @values right, left
   */
  direction: {
    type: String,
    default: 'right',
  },
  /**
   * リンク先パス
   */
  link: {
    type: String,
    default: '',
  },
  /**
   * 無効状態
   */
  disabled: {
    type: Boolean,
    default: false,
  },
  /**
   * 色
   * @values primary, secondary, success, danger, warning, info, light, dark(bootstrapの色指定を参考:https://getbootstrap.jp/docs/5.0/components/buttons/),
   */
  buttonColor: {
    type: String,
    default: 'transparent',
  },
  /**
   * なりゆき幅
   */
  contentFit: {
    type: Boolean,
    default: false,
  },
  /**
   * 枠線を残してボタンの背景色を透過状態
   */
  outlined: {
    type: Boolean,
    default: false,
  },
  /**
   * 影の状態(デフォルトはtrue)
   */
  shadow: {
    type: Boolean,
    default: true,
  },
  /**
   * 角丸状態(デフォルトはtrue)
   */
  rounded: {
    type: Boolean,
    default: true,
  },
  /**
   * 矢印の向き
   * @values right, left, top, bottom
   */
  facing: {
    type: String,
    default: 'right',
  },
  newButton: {
    type: Boolean,
    default: false,
  },
})

const classObject = computed(() => {
  return {
    'content-fit': props.contentFit,
    left: props.direction === 'left',
    right: props.direction === 'right',
  }
})

const transformValue = computed(() => {
  const value = {
    right: 'transform: rotate(0deg)',
    left: 'transform: rotate(180deg)',
  }
  return value[props.direction]
})
</script>

<style lang="scss" scoped>
.arrow-button {
  position: relative;
  .icon-arrow {
    position: absolute;
    width: 2.4rem;
  }

  &.left .icon-arrow {
    left: 1.6rem;
  }
  &.right .icon-arrow {
    right: 1.6rem;
  }

  &.content-fit {
    &.left .icon-arrow {
      left: 0.4rem;
    }
    &.right .icon-arrow {
      right: 0.4rem;
    }
  }
}
</style>
